








import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {},
})
export default class App extends Vue {
  get backgroundColor(): string {
    return String(this.$vuetify.theme.themes.light.background);
  }
}
